module.exports = __webpack_public_path__ + "static/media/mortgage-release.2dc863f6.svg";